import React, {Component} from 'react';
import { Col, Grid, Row } from '../../node_modules/react-bootstrap/lib/';
import Gallery from 'react-photo-gallery';

const PHOTO_SET = [
 
  {
    src: '/logo.jpg',
    width: 0.48,
    height: 0.35
  }
];

class Footer extends Component {
  render() {
    return (

		<Grid className="container-fluid">
			<Row className="show-grid">
				<Col md={1}>				
				</Col>
				<Col xs={4} md={5}>
	 				 <Gallery margin={10} columns={3} photos={PHOTO_SET} />
				</Col>
				<Col xs={8} md={5}>
					<center><h3>EXPERTIME</h3><h4><p>Cronometraje de eventos deportivos</p></h4><p>
					© 2018 - www.expertime.com.ar</p></center>
				</Col>
				<Col md={1}>				
				</Col>
			</Row>
		</Grid>
	);
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js